import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils/index.js.mjs';

function SvgIcRemoveFill(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4 12.11c0-.89.72-1.61 1.61-1.61h12.78a1.61 1.61 0 1 1 0 3.219H5.61A1.61 1.61 0 0 1 4 12.109"
  }));
}
var IcRemoveFill = createNolIcon(/*#__PURE__*/forwardRef(SvgIcRemoveFill));

export { IcRemoveFill as I };
